import { MapPin, Megaphone, Sparkles, PawPrint, Languages, Globe } from "lucide-react";

const featuresData = [
  {
    icon: MapPin,
    title: "Powered by Google",
    description: "Utilize the Google Places API to find shelters, veterinarians, and animal resources worldwide.",
  },
  {
    icon: Megaphone,
    title: "NASA-Powered Alerts",
    description: "Get real-time emergency notifications through our integration with NASA's disaster alert systems.",
  },
  {
    icon: Sparkles,
    title: "AI Search Powered by Google Gemini",
    description: "Find location-based animal welfare services, shelters, and emergency contacts seamlessly with intelligent search powered by Google Gemini.",
  },
  {
    icon: PawPrint,
    title: "Lost, Found & PSA Notifications",
    description: "Stay connected with your community and receive instant updates on missing animals and important PSAs.",
  },
  {
    icon: Languages,
    title: "20+ Languages Supported",
    description: "Connect with animal lovers worldwide with built-in multilingual support.",
  },
  {
    icon: Globe,
    title: "Global Access",
    description: "Our platform serves users across the world, ensuring everyone can access critical animal welfare resources.",
  },
];

export default featuresData;
